import { __decorate } from "tslib";
import { Component, Vue, Prop } from 'vue-property-decorator';
import moment from 'moment';
import { getOtaUploadList, delelteOtaUploadList } from '@blade-sxp/ota-management/api/index';
import { getFileSize } from '@blade/common/utils/file';
import AuthItem from '@blade/common/components/auth/auth-item.vue';
import copyButton from '@blade/common/components/copy-button.vue';
import { map } from 'lodash';
let default_1 = class default_1 extends Vue {
    keywords;
    confirm = '';
    pagination = {
        page: 1,
        size: 10,
        total: 0,
    };
    type = [];
    dataList = [];
    handleCreate() {
        this.$router.push('/setting/otaManagement/otaUpload');
    }
    handleSizeChange(size) {
        this.pagination.size = size;
        this.refresh();
    }
    handleCurrentChange(page) {
        this.pagination.page = page;
        this.refresh();
    }
    getList(keywords) {
        const data = {
            keyword: keywords,
            packageTypeList: this.type,
            page: this.pagination.page,
            size: this.pagination.size,
        };
        getOtaUploadList(data)
            .then(({ data: { data: { list, total }, }, }) => {
            this.dataList = map(list, (item) => ({ ...item, size: getFileSize(item.size) })) || [];
            this.pagination.total = total;
        })
            .catch((err) => {
            this.$message({
                message: err,
                type: 'error',
            });
        });
    }
    handleDelete(sid) {
        this.$elconfirm(`${this.$t('confirmDelete')}`, {
            type: 'warning',
            center: true,
            confirmButtonText: `${this.$t('common.confirm')}`,
            callback: (action) => {
                if (action === 'confirm') {
                    delelteOtaUploadList(sid)
                        .then((res) => {
                        this.$message({
                            message: res.data.message,
                            type: 'success',
                        });
                        this.refresh();
                    })
                        .catch((err) => {
                        this.$message({
                            message: err,
                            type: 'error',
                        });
                    });
                }
            },
        });
    }
    refresh() {
        this.getList(this.keywords);
    }
    mounted() {
        this.refresh();
    }
};
__decorate([
    Prop()
], default_1.prototype, "keywords", void 0);
default_1 = __decorate([
    Component({
        name: 'deviceList',
        components: { AuthItem, copyButton },
        filters: {
            toFormat: (num) => {
                return num ? moment(num).format('YYYY-MM-DD hh:mm:ss') : '';
            },
        },
        i18n: {
            messages: {
                'en-us': {
                    packageList: 'Package List',
                    upload: 'Upload',
                    Numbering: 'index',
                    filename: 'File Name',
                    version: 'Version',
                    size: 'Size',
                    uploadTime: 'Upload Time',
                    uploadUser: 'Uploader',
                    delete: 'Delete',
                    packageName: 'Update package name',
                    packageVsn: 'Update package version',
                    packageType: 'Package type',
                    currentPackageVsn: 'Current version',
                    deviceType: 'Device type',
                    deviceCnt: 'Number of devices',
                    deviceStatus: 'Device status',
                    online: 'online',
                    offline: 'offline',
                    taskStatus: 'Task status',
                    success: 'success',
                    fail: 'fail',
                    waiting: 'waiting',
                    taskleftSecond: 'The countdown',
                    taskCreateTime: 'Task creation time',
                    creatorName: 'Task creator',
                    details: 'details',
                    filtersData: [
                        { text: 'success', value: '1' },
                        { text: 'fail', value: '0' },
                        { text: 'waiting', value: '2' },
                    ],
                    deviceStatusFilter: [
                        { text: 'Normal', value: '1' },
                        { text: 'Disable', value: '0' },
                    ],
                    exportedData: 'Please select the data to be exported',
                    normal: 'Normal',
                    confirmDelete: 'Deleting update packages may affect device upgrades. Please be careful. Are you sure to delete it?',
                },
                zh: {
                    packageList: '更新包列表',
                    upload: '上传',
                    Numbering: '编号',
                    version: '版本号',
                    filename: '文件名',
                    size: '大小',
                    uploadTime: '上传时间',
                    uploadUser: '上传人',
                    delete: '删除',
                    packageName: '更新包名称',
                    packageVsn: '更新包版本号',
                    packageType: '包类型',
                    currentPackageVsn: '当前版本号',
                    deviceType: '设备类型',
                    deviceCnt: '设备数量',
                    deviceStatus: '设备状态',
                    online: '在线',
                    offline: '离线',
                    taskStatus: '任务状态',
                    success: '成功',
                    fail: '失败',
                    waiting: '等待升级',
                    taskleftSecond: '倒计时',
                    taskCreateTime: '任务创建时间',
                    creatorName: '任务创建人',
                    details: '详情',
                    filtersData: [
                        { text: '成功', value: '1' },
                        { text: '失败', value: '0' },
                        { text: '等待升级', value: '2' },
                    ],
                    deviceStatusFilter: [
                        { text: '正常', value: '1' },
                        { text: '异常', value: '0' },
                    ],
                    exportedData: '请选择需要导出的数据',
                    normal: '已连接',
                    confirmDelete: '删除更新包可能会影响设备升级，请谨慎操作，确认删除吗？',
                },
            },
        },
    })
], default_1);
export default default_1;
